import type { SxProps, Theme, TypographyProps } from "@mui/material";
import { Checkbox, FormControlLabel } from "@mui/material";
import useMergedSx from "@entrilia/shared/hooks/useMergedSx.ts";
import TypographyWithTooltip from "./TypographyWithTooltip.tsx";

interface Props {
  checked: boolean;
  label: string;
  tooltipText?: string;
  typographyProps?: TypographyProps;
  formControlLabelSx?: SxProps<Theme>;
  onChange: (newValue: boolean) => void;
  disabled?: boolean;
}

const CheckboxField = ({
  checked,
  onChange,
  label,
  tooltipText,
  typographyProps,
  formControlLabelSx,
  disabled,
}: Props) => {
  const mergedFormControlLabelSx = useMergedSx({ m: 0 }, formControlLabelSx);

  return (
    <FormControlLabel
      control={
        <Checkbox checked={checked} onChange={(_, value) => onChange(value)} sx={{ p: 1 }} disabled={disabled} />
      }
      label={<TypographyWithTooltip label={label} tooltipText={tooltipText} typographyProps={typographyProps} />}
      sx={mergedFormControlLabelSx}
    />
  );
};

export default CheckboxField;
